import { DOCUMENT, Injectable, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import { environment } from '../../environments/environment';

import { Metas } from './models/metas.model';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class MetasService {
  private title = inject(Title);
  private meta = inject(Meta);
  private document = inject(DOCUMENT);
  private router = inject(Router);

  addMetas(metas: Metas) {
    if (metas.robots === '' || !metas.robots || !environment.production) {
      metas.robots = 'noindex, nofollow';
    }
    // metas.robots = environment.production ? metas.robots : 'noindex, nofollow';
    this.title.setTitle(metas.title);
    this.meta.updateTag({
      name: 'description',
      content: metas.description,
    });
    this.meta.updateTag({
      property: 'og:title',
      content: metas.title,
    });
    this.meta.updateTag({
      property: 'og:description',
      content: metas.description,
    });
    this.meta.updateTag({
      property: 'og:image',
      content: metas.image ?? '',
    });

    this.meta.updateTag({
      name: 'DC.title',
      content: metas.title,
    });
    this.meta.updateTag({
      name: 'DC.description',
      content: metas.description,
    });
    this.meta.updateTag({
      name: 'DC.subject',
      content: metas.subject,
    });
    this.meta.updateTag({
      name: 'robots',
      content: metas.robots,
    });
    this.addCanonical();
  }

  addCanonical(custom = false, urlCanonical = '') {
    const canonical = this.document.getElementById('canonical-link');
    if (custom && urlCanonical !== '') {
      canonical?.setAttribute('href', urlCanonical);
    } else {
      const path = this.router.url.split(/[?#]/)[0];
      canonical?.setAttribute('href', environment.site.replace(/\/$/, '') + path);
    }
  }
}
